import React, {useEffect, useRef, useState} from 'react';
import item01 from '../../assets/images/about/section_03_item_01.png';
import item02 from '../../assets/images/about/section_03_item_02.png';
import item03 from '../../assets/images/about/section_03_item_03.png';

function AboutSection3() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 섹션이 화면에 보일 때만 애니메이션 적용
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // 섹션이 화면에서 벗어났을 때
          setIsVisible(false);
        }
      },
      {
        threshold: window.innerWidth <= 1024 ? 0.08 : 0.2, // 섹션이 20% 이상 보일 때 트리거
        rootMargin: '-50px' // 뷰포트 경계에서 50px 안쪽에서 트리거
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="howwework" 
      ref={sectionRef}
      className="w-full bg-[#F7F7F7] text-black py-[144px] md:pt-[128px] md:pb-[240px]"
    >
      <div className={`container mx-auto  transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        {/* 섹션 제목 */}
        <div className="mb-[30px] md:mb-[60px] lg:mb-[74px]">
          <p className="text-2xl md:text-4xl lg:text-xl font-semibold text-center">How We Work</p>
        </div>

        {/* 메인 텍스트 - 노란색 강조 */}
        <div className={'mb-[54px] md:mb-[100px]'}>
          <p className="text-4xl md:text-5xl lg:text-44 md:mb-4 lg:mb-4 font-bold text-center leading-[1.4]">
            챙기고는 누구보다 앞선 트렌드를 주도하며,</p>
          <p className="text-4xl md:text-5xl lg:text-44 font-bold text-center leading-[1.4]">
            아이디어에 머무르지 않고 실행으로 옮깁니다.</p>
        </div>

        <div className="hidden lg:block">
          <div className={`flex mx-auto gap-8 justify-around`}>

            <div className="flex flex-col justify-start items-center">
              <img src={item01} alt="Platform" className="aspect-386/234 w-sm mb-[68px]"/>
              <p className="text-26 font-bold mb-[20px]">빠른 성장의 재미</p>
              <p className="text-xl leading-[1.6] font-light text-center">
                챙기고는 빠르게 변화하는 시장 속에서<br/>
                치열하게 몰입하고 실행하며<br/>
                구성원들과 함께 즐겁고 빠르게 성장하고 있습니다.
              </p>
            </div>

            <div className="flex flex-col justify-start items-center">
              <img src={item02} alt="Marketing" className="aspect-386/234 w-sm mb-[68px]"/>
              {/* 텍스트 - 이미지 위에 중첩 */}
              <p className="text-26 font-bold mb-[20px]">스트레스 없는 조직문화</p>
              <p className="text-xl leading-[1.6] font-light text-center">
                불필요한 압박 없이 자율성과 신뢰를 바탕으로<br/>
                건강한 조직 문화를 가지고 있습니다.
              </p>
            </div>


            <div className="flex flex-col justify-start items-center">
              <img src={item03} alt="Trade" className="aspect-386/234 w-sm mb-[68px]"/>
              {/* 텍스트 - 이미지 위에 중첩 */}
              <p className="text-26 font-bold mb-[20px]">걱정 없는 회사생활</p>
              <p className="text-xl leading-[1.6] font-light text-center">
                강남역 도보 3분 초역세권 사무실과<br/>
                쾌적한 근무 환경, 수평적인 문화로<br/>
                구성원들의 일상적인 걱정을 최소화합니다.
              </p>
            </div>
            {/*<div className="text-center">*/}
            {/*  <h5 className="text-lg md:text-[22px] font-bold mb-4">수입·수출 / 브랜드 종합 개발</h5>*/}
            {/*  <p className="text-sm md:text-base leading-[1.7] font-light">*/}
            {/*    글로벌 유통과 브랜드 운영 계약을 통해<br/>*/}
            {/*    한국과海外를 잇는 Lifestyle 확산에 앞장섭니다.*/}
            {/*  </p>*/}
            {/*</div>*/}
          </div>
        </div>
        <div className="lg:hidden">
          <div className={`grid grid-cols-1 mx-auto`}>

            <div className="flex flex-col justify-center items-center mb-24 md:mb-40">
              <img src={item01} alt="Platform" className="aspect-386/234 w-3/5 mb-[24px] md:mb-[48px]"/>
              <p className="text-3xl md:text-42 font-bold mb-[24px] md:mb-[48px]">빠른 성장의 재미</p>
              <p className="text-22 md:text-3xl leading-[1.6] font-light text-center md:mb-2">
                챙기고는 빠르게 변화하는 시장 속에서 치열하게 몰입하고
              </p>
              <p className="text-22 md:text-3xl leading-[1.6] font-light text-center">
                실행하며 구성원들과 함께 즐겁고 빠르게 성장하고 있습니다.
              </p>
            </div>

            <div className="flex flex-col justify-center items-center mb-24 md:mb-40">
              <img src={item02} alt="Marketing" className="aspect-386/234 w-3/5 mb-[24px] md:mb-[48px]"/>
              <p className="text-3xl md:text-42 font-bold mb-[24px] md:mb-[48px]">스트레스 없는 조직문화</p>
              <p className="text-22 md:text-3xl leading-[1.6] font-light text-center md:mb-2">
                불필요한 압박 없이 자율성과 신뢰를 바탕으로</p>
              <p className="text-22 md:text-4xl leading-[1.6] font-light text-center">
                 건강한 조직 문화를 가지고 있습니다. </p>
            </div>


            <div className="flex flex-col justify-center items-center">
            <img src={item03} alt="Trade" className="aspect-386/234 w-3/5 mb-[24px] md:mb-[48px]"/>
              <p className="text-3xl md:text-42 font-bold mb-[24px] md:mb-[48px]">걱정 없는 회사생활</p>
              <p className="text-22 md:text-3xl leading-[1.6] font-light text-center md:mb-2">
                강남역 도보 3분 초역세권 사무실과 쾌적한 근무 환경,</p>
              <p className="text-22 md:text-3xl leading-[1.6] font-light text-center">
                수평적인 문화로 구성원들의 일상적인 걱정을 최소화합니다.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection3;